import { CATEGORY } from "../types/category.type";

const initialState = {
  loading: true,
  data: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CATEGORY.SUCCESS_FETCH:
      return {
        loading: false,
        data: action.payload,
        error: "",
      };
    case CATEGORY.FAIL_FETCH:
      return {
        loading: false,
        data: [],
        error: action.payload,
      };
    default:
      return { ...state };
  }
};
export default reducer;
